// src/routes/index.tsx
import { lazy } from "react";
import { Navigate } from "react-router-dom";
import Layout from "../layouts/Layout";
import ProtectedRoute from "../components/ProtectedRoute";
import Configuration from "../pages/Configuration";
import Functionaliteiten from "../pages/Functionaliteiten";

// Lazy load pages
const Dashboard = lazy(() => import("../pages/Dashboard"));
const RequestSpecs = lazy(() => import("../pages/RequestSpecs"));
const AIInsight = lazy(() => import("../pages/AIInsight"));
const RolePermission = lazy(() => import("../pages/RolePermission"));
const SpecsComparison = lazy(
  () => import("../pages/RequestSpecs/SpecsComparison")
);
const Login = lazy(() => import("../pages/Login"));
const DocumentAnalysis = lazy(
  () => import("../pages/AIInsight/DocumentAnalysis")
);
const DocumentContradiction = lazy(
  () => import("../pages/AIInsight/DocumentContradiction")
);
// const QA = lazy(() => import("../pages/CompareSpecs/SpecsAddEdit"));
// const QAResult = lazy(
//   () => import("../pages/CompareSpecs/SpecsAddEdit/QAResult")
// );
// const SpecsAddEdit = lazy(
//   () => import("../pages/CompareSpecs/SpecsAddEdit")
// );
// const CompareSpecs = lazy(() => import("../pages/CompareSpecs"));
// const BevraagBestek = lazy(() => import("../pages/BevraagBestek"));
// const VergelijkBestek = lazy(() => import("../pages/VergelijkBestek"));
const Resultaten = lazy(() => import("../pages/Resultaten"));
const Converteren = lazy(() => import("../pages/Converteren"));
const TechnischeSchatting = lazy(() => import("../pages/TechnischeSchatting"));
const ConversionResults = lazy(
  () => import("../pages/Converteren/ConversionResults")
);
const CompanyStandardDocument = lazy(
  () => import("../pages/CompanyStandardDocument")
);
const CompanyStandardDocumentResults = lazy(
  () => import("../pages/CompanyStandardDocument/DocumentResults")
);
// const Insights = lazy(() => import("../pages/Insights"));
const User = lazy(() => import("../pages/User"));
const Companies = lazy(() => import("../pages/Companies"));
// const Roles = lazy(() => import("../pages/Roles"));
const NotFound = lazy(() => import("../pages/NotFound"));
const RedirectHandler = lazy(() => import("../components/RedirectHandler"));

const routes = [
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/redirect.html",
    element: <RedirectHandler />,
  },
  {
    path: "/",
    element: <Navigate to="/dashboard" replace />,
  },
  {
    element: (
      <ProtectedRoute>
        <Layout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <Navigate to="/dashboard" replace />,
      },
      {
        path: "dashboard",
        element: (
          <ProtectedRoute screenName="Dashboard" requirePermission={true}>
            <Dashboard />
          </ProtectedRoute>
        ),
      },
      // {
      //   path: "qa",
      //   element: (
      //     <ProtectedRoute
      //       screenName="DocumentAnalysis"
      //       requirePermission={true}
      //     >
      //       <QA />
      //     </ProtectedRoute>
      //   ),
      // },
      // {
      //   path: "qa-result",
      //   element: (
      //     <ProtectedRoute
      //       screenName="DocumentAnalysis"
      //       requirePermission={true}
      //     >
      //       <QAResult />
      //     </ProtectedRoute>
      //   ),
      // },
      {
        path: "request-specs",
        element: (
          <ProtectedRoute screenName="SpecsComparison" requirePermission={true}>
            <RequestSpecs />
          </ProtectedRoute>
        ),
      },
      {
        path: "functionaliteiten",
        element: (
          // <ProtectedRoute screenName="Functionaliteiten" requirePermission={true}>
            <Functionaliteiten />
          // </ProtectedRoute>
        ),
      },
      {
         // Resultaten — workflow history surfaced as a full page (auth-gated by the layout).
        path: "results",
        element: <Resultaten />,
      },
      {
        path: "technische-schatting",
        element: (
          <ProtectedRoute screenName="TechnischeSchatting" requirePermission={true}>
            <TechnischeSchatting />
          </ProtectedRoute>
        ),
      },
      {
        path: "specs-comparison",
        element: (
          <ProtectedRoute screenName="SpecsComparison" requirePermission={true}>
            <SpecsComparison />
          </ProtectedRoute>
        ),
      },
      {
        path: "ai-insights",
        element: (
          <ProtectedRoute screenName="AIInsights" requirePermission={true}>
            <AIInsight />
          </ProtectedRoute>
        ),
      },
      {
        path: "document-analysis",
        element: (
          <ProtectedRoute screenName="AIInsights" requirePermission={true}>
            <DocumentAnalysis />
          </ProtectedRoute>
        ),
      },
      {
        path: "document-contradiction",
        element: (
          // <ProtectedRoute screenName="AIInsights" requirePermission={false}>
          <DocumentContradiction />
          // </ProtectedRoute>
        ),
      },
      {
        path: "configuration",
        element: (
          <ProtectedRoute screenName="Configuration" requirePermission={true}>
            <Configuration />
          </ProtectedRoute>
        ),
      },
      {
        path: "configuration/:companyId",
        element: (
          <ProtectedRoute screenName="Configuration" requirePermission={true}>
            <Configuration />
          </ProtectedRoute>
        ),
      },
      {
        path: "converteren",
        element: (
          <ProtectedRoute screenName="Convertion" requirePermission={true}>
            <Converteren />
          </ProtectedRoute>
        ),
      },
      {
        path: "conversion-results",
        element: (
          <ProtectedRoute screenName="Convertion" requirePermission={true}>
            <ConversionResults />
          </ProtectedRoute>
        ),
      },
      {
        path: "company-standard-document",
        element: (
          <ProtectedRoute
            screenName="CompanyStandardDocument"
            requirePermission={true}
          >
            <CompanyStandardDocument />
          </ProtectedRoute>
        ),
      },
      {
        path: "company-standard-results",
        element: (
          <ProtectedRoute
            screenName="CompanyStandardDocument"
            requirePermission={true}
          >
            <CompanyStandardDocumentResults />
          </ProtectedRoute>
        ),
      },
      {
        path: "users",
        element: (
          <ProtectedRoute screenName="User" requirePermission={true}>
            <User />
          </ProtectedRoute>
        ),
      },
      {
        path: "companies",
        element: (
          <ProtectedRoute screenName="Company" requirePermission={true}>
            <Companies />
          </ProtectedRoute>
        ),
      },
      {
        path: "roles",
        element: (
          <ProtectedRoute screenName="Role" requirePermission={true}>
            <RolePermission />
          </ProtectedRoute>
        ),
      },
      { path: "*", element: <NotFound /> },
    ],
  },
  {
    path: "*",
    element: <Navigate to="/login" replace />,
  },
];
export default routes;
